export default __webpack_public_path__ + "images/3a8864a2c84632c95a3e2eb73b57819c-startup_small_business_small.webp";